/*
 * @创建文件时间: 2019-10-29 15:53:48
 * @最后修改人        : lfq
 * @最后修改时间       : 2020-01-03 16:23:23
 * @联系Qq:1638245306
 * @文件介绍: 权限管理
 */
import store from '@/store'
import util from '@/libs/util.js'

export const verifyAuthority = function(authorityCode) {
    //return true;
    // 判断是不是有权限信息
    if (typeof authorityCode !== 'string') {
        return false
    }
    // 分解所需权限
    let keys = authorityCode.split('.')

    // 遍历权限列表
    //let authorities = store.getters['d2admin/user/getAuthorities'] || []
    let authorities = util.session.get('authorities').split(',') || []
    for (let i = 0; i < authorities.length; i++) {
        let resource = authorities[i]
            // if ('owner.*' === resource) {
            //     return true
            // } else if ('develop.*' === resource) {
            //     return keys[0] !== 'owner'
            // } else if ('system.*' === resource) {
            //     return !(keys[0] === ('owner') || keys[0] === ('develop'))
            // }
        if (resource === authorityCode) {
            return true
        }
        // let authorityKey = resource.split('.')

        // for (let j = 0; j < authorityKey.length; j++) {
        //     if (j === keys.length - 1) {
        //         break
        //     }
        //     if (authorityKey[j] === '*') {
        //         return true
        //     } else if (authorityKey[j] === keys[j]) {
        //         if (j === keys.length - 1) {
        //             return true
        //         }
        //     } else {
        //         return false
        //     }
        // }
    }
    return false
}